<template>
    <Header ueberschrift="Funk" />
    <div id="funkview">
        <div id="funk">
            <h1>Statustasten:</h1>
            <div><p class="status">0</p><p class="text">Dringender Sprechwunsch</p></div>
            <div><p class="status">1</p><p class="text">Einsatzbereit Funk</p></div>
            <div><p class="status">2</p><p class="text">Einsatzbereit auf Wache</p></div>
            <div><p class="status">3</p><p class="text">Einsatz übernommen</p></div>
            <div><p class="status">4</p><p class="text">Am Einsatzort</p></div>
            <div><p class="status">5</p><p class="text">Sprechwunsch</p></div>
            <div><p class="status">6</p><p class="text">Nicht einsatzbereit</p></div>
            <br>
            <p>Statusmeldungen zur ILS durch 2 sek. drücken der Zahlentaste</p>
        </div>
        <div id="funkrufnamen">
            <h1>Rufnamen:</h1>
            <div id="fahrzeugBox">
                <div class="rufCard" v-for="art in this.fahrzeugarten" :key="art.fahrzeugArtID" @click="this.openFahrzeugPopup(art)">
                    <h2 class="rufHeader">
                        {{ art.name }}
                    </h2>
                    <h3 class="rufNamen">{{ art.rufName }}</h3>
                    <img v-if="art.imagePath != null" class="rufImg" :src="art.imagePath">
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'
import {Fahrzeugarten} from '@/backend_controller/fahrzeugarten.js';
import Swal from 'sweetalert2';

export default {
    name: 'FunkView',
    components: {
        Header,
        Footer,
        Fahrzeugarten
    },
    data() {
        return {
            fahrzeugarten: []
        }
    },
    methods: {
        async openFahrzeugPopup(art){
            console.log(art);
            var html = "";
            html += `<img src=`+ art.imagePath +` style="margin-left:0 !important; margin-right: 0 !important; width: 80% !important">`;
            //html += `<input style="width: 90%" id="rufName" maxLength="5" class="swal2-input" placeholder="Rufname" style="margin-left:0 !important; margin-right: 0 !important; width: 90% !important" value="`+art.rufName+`">`;
            html+= `<h2>` + art.rufName + `</h2>`;

            const { value: formValues } = await Swal.fire({
                title: art.bezeichnung+" ("+ art.name +")",
                html: html,
                focusConfirm: false,
                preConfirm: () => {
                    return{
                    }
                }
            });
        }
    },
    async created() {
        //this.getUser('sebastianpfuelb@gmail.com');
        this.fahrzeugarten = await Fahrzeugarten.get();
        this.fahrzeugarten.sort((a, b) => {
            const [aMain, aSub] = a.rufName.split('/').map(Number);
            const [bMain, bSub] = b.rufName.split('/').map(Number);
            return aMain - bMain || aSub - bSub;
        });
        console.log(this.fahrzeugarten);
    },
}
</script>

<style lang="scss">
#funkview{
    display: flex;
    flex-wrap:wrap;
    padding-top: 4.5rem;
    justify-content: center;
    background-color: white;
    width: 100vw !important;
    padding-bottom: 4.5rem;
}
#funk{
    //margin-bottom: 4.5rem;
    width: 50vw;
    min-width: 500px;

    h1{
        padding-top: 0.5rem !important;
        margin-bottom: 0rem;
    }

    p{
        display: inline-block;
        text-align: left;
        padding-left: 0.7rem;
        padding-right: 0.7rem;
        font-size: large;
        padding-top: 0rem;
        padding-bottom: 0rem;
        margin-bottom: 0.7rem;
    }
}
#funkrufnamen{
    //margin-bottom: 4.5rem
    width: 50vw;
    min-width: 500px;
    #fahrzeugBox{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        //background-color: rgb(238, 239, 243);
        gap: 0.3rem;
        align-content: start;
        padding: 0.7rem;
        padding-top: 0 !important;

        .rufCard{                
            margin-left: 0.3rem;
            margin-top: 0.3rem;
            min-width: 11rem;
            height: 11rem;
            width: 15vw;
            //background-color: white;
            background-color:rgb(244, 244, 244);
            //box-shadow: 0 0 0 2px rgba(221, 222, 226, 0.486);
            border-radius: 5px;
            .rufHeader{
                margin-bottom: 0;
            }
            .rufNamen{
                margin-top: 0;
                color: darkgray
            }
            .rufImg{
                max-height: 5rem;
            }
        }
    }
}

    @media screen and (max-width: 1000px){
        #funk{
            min-width: auto;
            width: 100vw;
        }

        #funkrufnamen{
            min-width: auto;
            width: 100vw;
        }
    }

    @media screen and (max-height: 768px) {
        #funk{
            margin-bottom: 10vh;
        }
    }

    @media screen and (max-width: 500px) {
        #funk{
            min-width: auto !important;
            width: 100vw !important;
        }

        .rufCard{
            min-width: auto !important;
            width: 40vw !important;
        }

        #funkrufnamen{
            min-width: auto !important;
            width: 100vw !important;
        }
    }
</style>

